module.exports = __webpack_public_path__ + "static/media/BMW_Grey_Logo.f9973621.svg";